<template>
<div>
    <div class="full split-bottom">
        <div class="header">
            <div class="label">Persönliche Daten</div>
        </div>
        <div class="third left">
            <div class="full">
                <div class="third left">
                    <div class="label">Geburtsdatum</div>
                </div>
                <div class="twothirds right cd-input">
                    <input @input="update('dob', true)" type="date" v-model="dateOfBirth"/>
                </div>
            </div>
            <div class="full split-bottom">
                <div class="third left">
                    <div class="label">SV Nummer</div>
                </div>
                <div class="twothirds right cd-input" v-bind:class="{bottomline: $helpers.isEmpty(employee.socialsecurity)}">
                    <input @keydown.enter="update('socialsecurity')" @blur="update('socialsecurity')" type="text" v-model="employee.socialsecurity"/>
                </div>
            </div>
            <div class="full">
                <div class="third left">
                    <div class="label">Staatsbürger</div>
                </div>
                <div class="twothirds right" style="z-index: 1000;">
                    <searchbar class="filters" ref="filtersNationality" :searchbar="filtersNationality"/>
                </div>
            </div>
            <div class="full split-bottom">
                <div class="third left">
                    <div class="label">Bürgertyp</div>
                </div>
                <div class="twothirds right" style="z-index: 990;"> <!-- lower z-index then selection above ensure above selection overlays this one -->
                    <searchbar class="filters" ref="filtersCitizen" :searchbar="filtersCitizen"/>
                </div>
            </div>
            
        </div>
        <div class="third mid">
            <div class="full">
                <div class="third left">
                    <div class="label">Religion</div>
                </div>
                <div class="twothirds right cd-input" v-bind:class="{bottomline: $helpers.isEmpty(employee.religion)}">
                    <input @keydown.enter="update('religion')" @blur="update('religion')" type="text" v-model="employee.religion"/>
                </div>
            </div>
            <div class="full split-bottom">
                <div class="third left">
                    <div class="label">Geschlecht</div>
                </div>
                <div class="third mid exact">
                    <div class="label data">
                        männlich &nbsp;
                        <i class="fas fa-check-circle checkbox coredata" @click="update('gender', false, 'M');" v-bind:class="{'true' : employee.gender == 'M', 'false' : employee.gender != 'M'}"></i>
                    </div>
                </div>
                <div class="third right">
                    <div class="label data">
                        weiblich &nbsp;
                        <i class="fas fa-check-circle checkbox coredata" @click="update('gender', false, 'F');" v-bind:class="{'true' : employee.gender == 'F', 'false' : employee.gender != 'F'}"></i>
                    </div>
                </div>
            </div>
            <div class="full">
                <div class="twothirds left">
                    <div class="label">50% Behinderung</div>
                </div>
                <div class="third right">
                    <i class="fas fa-check-circle checkbox coredata" @click="update('disability', false, !employee.disability)" v-bind:class="{'true' : employee.disability, 'false' : !employee.disability}"></i>
                </div>
            </div>
            <div class="full split-bottom">
                <div class="label">&nbsp;</div>
            </div>
            <div class="full">
                <div class="third left">
                    <div class="label">Stammposition</div>
                </div>
                <div class="twothirds right" style="z-index: 1000;">
                    <searchbar class="filters" ref="filtersSpot" :searchbar="filtersSpot"/>
                </div>
            </div>
            <div class="full">
                <div class="third left">
                    <div class="label">Plan Typ</div>
                </div>
                <div class="twothirds right" style="z-index: 990;"> <!-- lower z-index then selection above ensure above selection overlays this one -->
                    <searchbar class="filters" ref="filtersType" :searchbar="filtersType"/>
                </div>
            </div>
            <div class="full">
                <div class="third left">
                    <div class="label">Plan Optionen</div>
                </div>
                <div class="twothirds right" style="z-index: 980;"> <!-- lower z-index then selection above ensure above selection overlays this one -->
                    <searchbar class="filters" ref="filtersRule" :searchbar="filtersRule"/>
                </div>
            </div>
        </div>
        <div class="third right">
            <div class="full">
                <div class="label">Führerschein</div>
                <i class="fas fa-check-circle checkbox coredata" @click="update('driverslicense', false, !employee.driverslicense)" v-bind:class="{'true' : employee.driverslicense, 'false' : !employee.driverslicense}"></i>
            </div>
            <div class="full split-bottom">
                <div class="third left">
                    <div class="label">Ablaufdatum</div>
                </div>
                <div class="twothirds right cd-input">
                    <input @input="update('dlExpiry', true)" type="date" v-model="dlExpiry"/>
                </div>
            </div>
            <div class="full">
                <div class="label">Erste Hilfe Kurs</div>
                <i class="fas fa-check-circle checkbox coredata" @click="update('firstaidcourse', false, !employee.firstaidcourse)" v-bind:class="{'true' : employee.firstaidcourse, 'false' : !employee.firstaidcourse}"></i>
            </div>
            <div class="full split-bottom">
                <div class="third left">
                    <div class="label">Ablaufdatum</div>
                </div>
                <div class="twothirds right cd-input">
                    <input @input="update('faExpiry', true)" type="date" v-model="faExpiry"/>
                </div>
            </div>
        </div>
    </div>
    <div class="full split-bottom">
        <div class="header">
            <div class="label">Kontakt</div>
            <div class="header-right">
                <div class="button small">
                    <div class="label">
                        Daten anfordern
                    </div>
                </div>
            </div>
        </div>
        <div class="third left">
            <div class="full">
                <div class="third left">
                    <div class="label">Anschrift</div>
                </div>
                <div class="twothirds right cd-input" v-bind:class="{bottomline: $helpers.isEmpty(employee.address)}">
                    <input @keydown.enter="update('address')" @blur="update('address')" type="text" v-model="employee.address"/>
                </div>
            </div>
            <div class="full split-bottom">
                <div class="third left">
                    <div class="label">PLZ</div>
                </div>
                <div class="twothirds right cd-input" v-bind:class="{bottomline: $helpers.isEmpty(employee.postalCode)}">
                    <input @keydown.enter="update('postalCode')" @blur="update('postalCode')" type="text" v-model="employee.postalCode"/>
                </div>
            </div>
            <div class="full">
                <div class="third left">
                    <div class="label">Telefon</div>
                </div>
                <div class="twothirds right cd-input" v-bind:class="{bottomline: $helpers.isEmpty(employee.homephone)}">
                    <input @keydown.enter="update('homephone')" @blur="update('homephone')" type="text" v-model="employee.homephone"/>
                </div>
            </div>
            <div class="full">
                <div class="third left">
                    <div class="label">Mobil</div>
                </div>
                <div class="twothirds right cd-input" v-bind:class="{bottomline: $helpers.isEmpty(employee.mobilephone)}">
                    <input @keydown.enter="update('mobilephone')" @blur="update('mobilephone')" type="text" v-model="employee.mobilephone"/>
                </div>
            </div>
        </div>
        <div class="third mid">
            <div class="full">
                <div class="third left">
                    <div class="label">Stadt</div>
                </div>
                <div class="twothirds right cd-input" v-bind:class="{bottomline: $helpers.isEmpty(employee.city)}">
                    <input @keydown.enter="update('city')" @blur="update('city')" type="text" v-model="employee.city"/>
                </div>
            </div>
            <div class="full split-bottom">
                <div class="third left">
                    <div class="label">Land</div>
                </div>
                <div class="twothirds right" style="z-index: 1000;">
                    <searchbar class="filters" ref="filtersCountry" :searchbar="filtersCountry"/>
                </div>
            </div>
            <div class="full">
                <div class="third left">
                    <div class="label">E-Mail</div>
                </div>
                <div class="twothirds right cd-input" v-bind:class="{bottomline: $helpers.isEmpty(employee.email)}">
                    <input @keydown.enter="update('email')" @blur="update('email')" type="text" v-model="employee.email"/>
                </div>
            </div>
            <div class="full">
                <div class="twothirds right offset">
                    <div class="button small">
                        <div class="label">
                            App Einladung senden
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="third right">

        </div>
    </div>
    <div class="full split-bottom">
        <div class="third left">
            <div class="header">
                <div class="label">Kontoinformationen</div>
                <div class="header-right">
                    <div class="button small">
                        <div class="label">
                            Daten anfordern
                        </div>
                    </div>
                </div>
            </div>
            <div class="full">
                    <div class="third left">
                        <div class="label">IBAN</div>
                    </div>
                    <div class="twothirds right cd-input" v-bind:class="{bottomline: $helpers.isEmpty(employee.iban)}">
                        <input @keydown.enter="update('iban')" @blur="update('iban')" type="text" v-model="employee.iban"/>
                    </div>
                </div>
                <div class="full">
                    <div class="third left">
                        <div class="label">BIC</div>
                    </div>
                    <div class="twothirds right cd-input" v-bind:class="{bottomline: $helpers.isEmpty(employee.bic)}">
                        <input @keydown.enter="update('bic')" @blur="update('bic')" type="text" v-model="employee.bic"/>
                    </div>
                </div>
        </div>
        <div class="third mid">
        </div>
        <div class="third right">
        </div>
    </div>
</div>
</template>

<script>
import grid from '../uicomponents/grid.vue'
import dropdown from '../uicomponents/dropdown.vue'
import searchbar from '../uicomponents/searchbar.vue'
import imagecrop from '../uicomponents/imagecrop.vue'

export default {
    components: {
        grid,
        dropdown,
        searchbar,
        imagecrop,
    },
    name: 'employeecoredata',
    data() {
        return {
            cuiData:{},
            countryMap:{},
            citizenTypeMap:{},
            filtersNationality: {},
            itemsNationality: [],
            filtersCountry: {},
            itemsCountry: [],
            filtersCitizen: {},
            itemsCitizen: [],
            types: [],
            filtersType: {},
            rules: [],
            filtersRule: {},
            cspots: [],
            filtersSpot: {},
            dataFiltered: [],
            loading: true,
            dragWatch: -1,
            mouseCurrent: {
                x: 0,
                y: 0
            },
            mouseDragStart: {
                x: 0,
                y: 0
            },
            scrolling: false,
            scrollTop: 150,
            dropdowns: [],
            savedEmployee: {}
        }
    },
    watch: {
        nameFilter: function (val, oldVal) {
            if (val === '') {
                this.dataFiltered = this.gridData.data.slice();
                return;
            }
            this.dataFiltered = this.gridData.data.filter(e => (e.firstName.toLowerCase() + ' ' + e.lastName.toLowerCase()).indexOf(val.toLowerCase()) > -1);
        },
        spots: {
            handler(val, oldVal){
                this.cspots = val;
                this.updateSpotsDropdown();
            },
            deep: true
        },
        employeetypes: {
            handler(val, oldVal){
                this.types = val;
                this.updateTypesDropdown();
            },
            deep: true
        },
        employeerules: {
            handler(val, oldVal){
                this.rules = val;
                this.updateRulesDropdown();
            },
            deep: true
        },
        employee: function (val, oldVal){
            this.updateNationalityDropdown();
            this.updateCountryDropdown();
            this.updateCitizenTypeDropdown();
            this.updateSpotsDropdown();
            this.updateTypesDropdown();
            this.updateRulesDropdown();
        }
    },
    props: [
        "employee",
        "spots",
        "employeetypes",
        "employeerules",
        "uiData"
    ],
    computed: {
        dateOfBirth: {
            get: function(){
                var dateStr;
                if(this.employee.dob){
                    
                    dateStr = this.$helpers.extractDateString(this.employee.dob);
                }
                return dateStr;
            },
            set: function(val){
                this.employee.dob = val;
            }
        },
        dlExpiry: {
            get: function(){
                var dateStr;
                if(this.employee.dlExpiry){
                    dateStr = this.$helpers.extractDateString(this.employee.dlExpiry);
                }
                return dateStr;
            },
            set: function(val){
                this.employee.dlExpiry = val;
            }
        },
        faExpiry: {
            get: function(){
                var dateStr;
                if(this.employee.faExpiry){
                    dateStr = this.$helpers.extractDateString(this.employee.faExpiry);
                }
                return dateStr;
            },
            set: function(val){
                this.employee.faExpiry = val;
            }
        },
    },
    mounted(){
        this.cspots = this.spots;
        this.cuiData = this.uiData;
        this.cuiData.countries.forEach(item => this.countryMap[item.id] = item.label_de);
        this.cuiData.citizenTypes.forEach(item => this.citizenTypeMap[item.id] = item.label_de);
        this.types = this.employeetypes;
        this.rules = this.employeerules;
        this.savedEmployee = Object.assign({}, this.employee);

        this.updateCountryDropdown();
        this.updateNationalityDropdown();
        this.updateCitizenTypeDropdown();
        this.updateSpotsDropdown();
        this.updateTypesDropdown();
        this.updateRulesDropdown();
    },
    destroyed() {
    },
    methods: {
        updateNationalityDropdown(){
            var view = this;
            this.itemsNationality = [];
            // dropdown data country
            
            for(const val of this.cuiData.countries){
                this.itemsNationality.push({code: val.id, label: val.label_de, name: val.label_de});
            }
            this.filtersNationality = {
                toggled: false,
                displayedItems: this.itemsNationality,
                input: this.employee.nationality != undefined ? view.countryMap[view.employee.nationality] : 'bitte wählen',
                items: Object.values(this.itemsNationality),
                onceSelected: function ($event, item, searchbar){
                    view.update('nationality', false, item.code);
                },
                inheritedStyle: this.inheritedSearchbarStyle,
            }
        },
        updateCountryDropdown(){
            var view = this;
            this.itemsCountry = [];
            // dropdown data country
            for(const val of this.cuiData.countries){
                this.itemsCountry.push({code: val.id, label: val.label_de, name: val.label_de});
            }
            this.filtersCountry = {
                toggled: false,
                displayedItems: this.itemsCountry,
                input: this.employee.country != undefined? this.countryMap[this.employee.country] : 'bitte wählen',
                items: Object.values(this.itemsCountry),
                onceSelected: function ($event, item, searchbar){
                    view.update('country', false, item.code);
                },
                inheritedStyle: this.inheritedSearchbarStyle,
            }
        },
        updateCitizenTypeDropdown(){
            var view = this;
            this.itemsCitizen = [];
            // dropdown data citizenType
            for(const val of this.cuiData.citizenTypes){
                this.itemsCitizen.push({code: val.id, label: val.label_de, name: val.label_de});
            }
            this.filtersCitizen = {
                toggled: false,
                displayedItems: this.itemsCitizen,
                input: this.employee.citizenType != undefined? this.citizenTypeMap[this.employee.citizenType] : 'bitte wählen',
                items: Object.values(this.itemsCitizen),
                onceSelected: function ($event, item, searchbar){
                    view.update('citizenType', false, item.code);
                },
                inheritedStyle: this.inheritedSearchbarStyle,
            }
        },
        updateSpotsDropdown(){
            var view = this;
            // dropdown data spots
            this.filtersSpot = {
                toggled: false,
                displayedItems: this.cspots,
                input: this.employee.spotId != undefined? this.itemWithId(this.employee.spotId, this.spots).label : 'bitte wählen',
                items: Object.values(this.cspots),
                onceSelected: function ($event, item, searchbar){
                    view.update('spotId', false, item.id);
                },
                inheritedStyle: this.inheritedSearchbarStyle,
            }
        },
        updateTypesDropdown(){
            var view = this;
            // dropdown data employeetype
            this.filtersType = {
                toggled: false,
                displayedItems: this.types,
                input: this.employee.typeId != undefined? this.itemWithId(this.employee.typeId, this.types).label : 'bitte wählen',
                items: Object.values(this.types),
                onceSelected: function ($event, item, searchbar){
                    view.update('typeId', false, item.id);
                },
                inheritedStyle: this.inheritedSearchbarStyle,
            }
        },
        updateRulesDropdown(){
            var view = this;
            // dropdown data employeerules
            this.filtersRule = {
                toggled: false,
                displayedItems: this.types,
                input: this.employee.ruleId != undefined? this.itemWithId(this.employee.ruleId, this.rules).label : 'bitte wählen',
                items: Object.values(this.rules),
                onceSelected: function ($event, item, searchbar){
                    view.update('ruleId', false, item.id);
                },
                inheritedStyle: this.inheritedSearchbarStyle,
            }
        },
        itemWithId(id, arr){
            for(const item of arr){
                if(item.id == id) return item;
            }
            // fallback, should not happen
            return {id: '' , name: '', label: ''};
        },
        inheritedSearchbarStyle(el) {
            $(el).find('.entry').css({
                'position': 'absolute',
                'top': '0px',
                'left': '0px',
                'height': '18px',
                'padding': '0px 1px',
                'color': 'var(--contrast-3)',
            });
            $(el).find('.fa-stack').css({
                'top': '0px',
                'margin-top': '0px',
                'margin-right': '4px',
                'right': '0px'
            });
            $(el).find('input').css({
                'box-shadow': 'none',
                'background': 'none'
            });
            $(el).find('.fa-angle-down').css({
                'color': '#ffffff'
            });
            $(el).find('.fa-circle').css({
                'color': 'var(--contrast-2)'
            });
            $(el).find('.items').css({
                position: 'absolute',
                top: '19px',
                left: '-1px',
                width: 'calc(100% + 2px)',
                'box-shadow': 'none',
            });
            $(el).find('.items .item:even').css({
                background: 'var(--contrast-1)'
            });
            $(el).find('.items .item:odd').css({
                background: 'var(--bg)'
            });
            $(el).find('.items .item').css({
                padding: '4px 0px 4px 4px'
            });
            $(el).find('.item .label').css({
                color: 'var(--contrast-5)',
                'font-size': '10px',
                'margin-top': '0px'
            });
        },
        OnEnter(itemHeader, item) {
            if (itemHeader.OnEnter !== null) {
                itemHeader.OnEnter(item);
            }
        },
        GetProfilePictureUrl(employee) {
            if (!employee.firstName || !employee.profile_picture_storageServerId) return '#e5e5e5';
            var d = new Date();
            return '#e5e5e5 no-repeat center/cover  url(https://fileserver1.meindienstplan.de/api/file?id=' + employee.profile_picture_storageServerId + '&accessToken=' + employee.profile_picture_storageServerToken + '&time=' + Date.now() + ')';
        },
        ToggleDropDown: function ($event, selection, offsetx, offsety) {
            var event = $event;
            var box = event.currentTarget.getBoundingClientRect();
            var dropdowns = this.dropdowns;
            this.dropdowns.push({
                items: selection,
                el: event.currentTarget,
                remainAfterSelect: true,
                toggled: true,
                offsetx: offsetx,
                offsety: offsety,
                posx: box.left + offsetx,
                posy: box.bottom + offsety,
                onceSelected: function ($eventInner, item, dropdown) {
                    var eventInner = $eventInner;
                    var boxInner = eventInner.currentTarget.getBoundingClientRect();
                    var temp = {
                        items: item.items,
                        //el: event.currentTarget,
                        offsetx: offsetx + 130,
                        offsety: offsety,
                        posx: box.left + offsetx + 130,
                        toggled: true,
                        posy: boxInner.bottom - 30,
                        pointerDirection: 3,
                        parentCallback: function () {
                            dropdown.toggled = false
                        }
                    };
                    dropdowns.push(temp);
                }
            });
        },
        Init(items, config) {},
        gender(code){
            switch(code){
                case 'm':
                case 'M':
                    return "männlich";
                case 'f':
                case 'F':
                    return "weiblich";
                default:
                    return "menschlich";
            }
        },
        // DATA UPDATE METHODS
        update(key, isDate=false, value=null){
            // show progress bar on top
            this.$Progress.start();

            if(value != null){
                this.employee[key] = value;
            }
            if(this.savedEmployee[key] != this.employee[key]){
                let view = this;
                if(key == 'spotId'){
                   
                    let url = '/api/sec/employee/linkspot';
                    url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee/linkspot');
                    let payload =  {
                        id: this.employee.id,
                        spotId: this.employee.spotId,
                        deleteOldSkill: true,
                        skillValue: 10,
                    }

                    this.axios({
                        method: 'put',
                        headers: {
                            'AUTHORIZATION': "bearer "+this.$store.state.jwt
                        },
                        url: url,
                        data: payload
                    }).then(response => {
                        if(response.data.type && response.data.type == 'SUCCESS'){
                            this.$Progress.finish();
                            this.$helpers.success('Gespeichert', 'Änderungen gespeichert!');
                            this.savedEmployee.spotId = this.employee.spotId;
                            this.$forceUpdate();
                        } else{
                            this.$Progress.fail();
                        }
                    }).catch(function (error) {
                        this.$Progress.fail();
                        console.log(error)
                    })
                } else {
                    let url = '/api/sec/employee';
                    url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee');
                    
                    let payload = {
                        'id': this.employee.id,
                        'updateFields':[key],
                        [key]: (isDate? this.$helpers.convertDateTimeString(this.employee[key]) : this.employee[key]) 
                    }
                    this.axios({
                        method: 'put',
                        headers: {
                            'AUTHORIZATION': "bearer "+this.$store.state.jwt
                        },
                        url: url,
                        data: payload
                    }).then(response => {
                        if(response.data.type && response.data.type == 'SUCCESS'){
                            this.$Progress.finish();
                            this.$helpers.success('Gespeichert', 'Änderungen gespeichert!');
                            this.savedEmployee[key] = this.employee[key];
                            this.$forceUpdate();
                        }else{
                            this.$Progress.fail();
                        }
                    }).catch(function (error) {
                        this.$Progress.fail();
                        console.log(error)
                    })
                }
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.searchbar.filters {
    height: 18px !important;
    display: block;
}
/*
.content *:not(.main-settings)>.half {
    height: 105px;
}
*/
</style>
